import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdAutoGraph, MdOutlineSmartToy, MdFitnessCenter, MdOutlineRealEstateAgent, MdOutlineHandshake, MdOutlineSpeakerNotes, MdShareLocation } from "react-icons/md";
import InputMask from "react-input-mask";

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Shimmer from '../../components/Shimmer';

import banner from '../../assets/images/banner.jpg';
import bruk_1 from '../../assets/images/bruk-1.png';
import bruk_2 from '../../assets/images/bruk-2.png';
import shape_top from '../../assets/images/shape-top.png';
import shape_bottom from '../../assets/images/shape-bottom.png';

import api from '../../services/api';

export default function Franquia() {
    
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [city, setCity] = useState('');
    const [message, setMessage] = useState('');

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState(false);
    const [error_message, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);

    async function submitContact(e){
        e.preventDefault();
        setLoading(true);
        try{
            if(name==="" || email==="" || phone==="" || city==="" || message===""){
                setLoading(false);
                setError(true);
                setErrorMessage('Preencha todos os campos!');
                return;
            }

            const response = await api.post('/contact-franquia', {
                name,
                email,
                phone,
                city,
                message,
            });

            setError(false);
            setLoading(false);
            setSuccess(true);
            setName('');
            setEmail('');
            setPhone('');
            setCity('');
            setMessage('');

        }catch(err){
            setLoading(false);
            setError(true);
            setErrorMessage('Erro ao enviar informações');
        }
    }

    return (
        <div className="page-wrapper">
            <Header />
            <div className="content-wrapper page-content">
                <h4 className="fw-semibold" data-aos="fade-up" data-aos-delay="50">Franquia</h4>
                <div className="row pt-4 pb-4">
                    <div className="content-section section-1">
                        <h2 data-aos="fade-up" data-aos-delay="100">Por que se tornar um Franqueado BRUK?</h2>
                        <div className="col-md-8 m-auto">
                            <div className="row">
                                <div className="col-md-6 m-auto content-box-why" data-aos="fade-up" data-aos-delay="150">
                                    <div>
                                        <MdAutoGraph />
                                        <p>Propósito de crescimento de sua equipe e da comunidade BRUK</p>
                                    </div>
                                </div>
                                <div className="col-md-6 m-auto content-box-why" data-aos="fade-up" data-aos-delay="200">
                                    <div>
                                        <MdOutlineSmartToy />
                                        <p>Tecnologia trabalhando para a melhor experiencia de seus alunos</p>
                                    </div>
                                </div>
                                <div className="col-md-6 m-auto content-box-why" data-aos="fade-up" data-aos-delay="250">
                                    <div>
                                        <MdFitnessCenter />
                                        <p>Treinamento para toda a sua equipe, alem de e-books complementares</p>
                                    </div>
                                </div>
                                <div className="col-md-6 m-auto content-box-why" data-aos="fade-up" data-aos-delay="300">
                                    <div>
                                        <MdOutlineRealEstateAgent />
                                        <p>Acompanhamos de perto seu box e a execução de seus projetos</p>
                                    </div>
                                </div>
                                <div className="col-md-6 m-auto content-box-why" data-aos="fade-up" data-aos-delay="350">
                                    <div>
                                        <MdOutlineSpeakerNotes />
                                        <p>Marketing com excelentes resultados</p>
                                    </div>
                                </div>
                                <div className="col-md-6 m-auto content-box-why" data-aos="fade-up" data-aos-delay="400">
                                    <div>
                                        <MdShareLocation />
                                        <p>Presença no mercado internacional</p>
                                    </div>
                                </div>
                                <div className="col-md-8 m-auto content-box-why" data-aos="fade-up" data-aos-delay="450">
                                    <div>
                                        <MdOutlineHandshake />
                                        <p>Consultoria com profissionais renomados pelo mercado disponíveis para o seu crescimento</p>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mt-5" data-aos="fade-up" data-aos-delay="500">
                                    <a href="#franquia" className="btn-border-mini">Torne-se um Franqueado</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-section section-2" data-aos="fade-up" data-aos-delay="50">

                        <div class="content-shape-top">
                            <img src={shape_top} />
                        </div>

                        <div className="row">
                            <div className="col-md-6 m-auto pt-4 pb-4">
                                <h2>Nosso time é o melhor</h2>
                                <p>A BRUK é formada por grandes visionários do mundo fitness.</p>
                                <p>Com <a href="https://www.instagram.com/tito.atc/" target="_blank" rel="noreferrer">Alexandre Tito</a> e <a href="https://www.instagram.com/amaro.gab/" target="_blank" rel="noreferrer">Gabriel Amaro</a>, especialistas em Gestão Empresarial, <a href="https://www.instagram.com/gus.witfitness/" target="_blank" rel="noreferrer">Coach Gus</a>, gestor de academias e especialista no esporte, e <a href="https://www.instagram.com/lapateam/" target="_blank" rel="noreferrer">Ricardo Lapa</a>, o maior empresário do ramo Fitness do Brasil, sendo fundador de dois projetos altamente bem sucedidos, o Lapa Team e a <a href="https://www.instagram.com/academiaonlinefoguete/" target="_blank" rel="noreferrer">Academia Online Foguete</a>.</p>
                            </div>
                        </div>

                        <div class="content-shape-bottom">
                            <img src={shape_bottom} />
                        </div>

                    </div>

                    <div className="content-section section-3">
                        <div className="col-md-6 m-auto">
                            <h2 data-aos="fade-up" data-aos-delay="50">Contamos com uma uma gestão inteligente e metodologias claras</h2>
                            
                            <p data-aos="fade-up" data-aos-delay="100">Nosso projeto de expansão é o movimento que irá revolucionar o mercado de box e academias, e pra isso, contamos com uma equipe completa para te auxiliar e instruir dentro da visão de negócio BRUK, assegurando o franqueado de que sua decisão foi assertiva.</p>
                        </div>
                        <div className="col-md-12 text-center mt-5" data-aos="fade-up" data-aos-delay="150">
                            <a href="#franquia" className="btn-border-mini">Torne-se um Franqueado</a>
                        </div>
                    </div>



                    <div className="content-section section-4">
                        <div class="content-shape-top">
                            <img src={shape_top} />
                        </div>
                        <div className="row">
                            <div className="col-md-6 m-auto" data-aos="fade-up" data-aos-delay="50">
                                <img src={bruk_1} />
                            </div>
                            <div className="col-md-6 m-auto" data-aos="fade-up" data-aos-delay="100">
                                <h2>Segmento promissor</h2>
                                <p>Há cerca de 8 milhões de clientes em espaços fitness brasileiros, e estima-se que <storng>47% da população não pratica o mínimo de atividades físicas</storng> recomendadas pela Organização Mundial da Saúde – 150 minutos por semana.</p>
                                <p>Isso quer dizer que só 4% da população nacional conta com algum tipo de estabelecimento com suporte mais especializado para realizar as suas atividades físicas.</p>
                                <p><storng>Sozinho, o mercado fitness do Brasil mobiliza cerca de 8 bilhões de reais por ano</storng> (o que atualmente representa 3% da indústria de serviços brasileira e 0,13% do PIB nacional.)</p>

                                <h2 className="pt-4">Nossa marca</h2>
                                <p>Os produtos da BRUK reforçam a identidade e o senso de comunidade que nós trabalhamos em nossas unidades. Nossos produtos representam o apoio e união entre nós e nossos alunos. </p>
                            
                            </div>
                        </div>
                    </div>

                    <div className="content-section section-5" data-aos="fade-up" data-aos-delay="50">
                        <div className="row row-first">
                            <h2>Sobre seu investimento</h2>
                            <div className="col-md-6 m-auto">
                                <div className="row">
                                    <div className="col-md-3 m-auto">
                                        <div className="section-5-box">
                                            <div className="section-5-title">Investimento</div>
                                            <div className="section-5-subtitle">a partir de R$250 mil</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 m-auto">
                                        <div className="section-5-box">
                                            <div className="section-5-title">Payback</div>
                                            <div className="section-5-subtitle">em média de 24 meses</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 m-auto">
                                        <div className="section-5-box">
                                            <div className="section-5-title">Rentabilidade</div>
                                            <div className="section-5-subtitle">de 8% ao mês</div>
                                        </div>
                                    </div>
                                    <div className="col-md-3 m-auto">
                                        <div className="section-5-box">
                                            <div className="section-5-title">Faturamento</div>
                                            <div className="section-5-subtitle">até 1,5 Milhão ao ano</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row row-last">
                            <div className="col-md-6 m-auto">
                                <h2>Invista na sua comunidade</h2>
                                <p>A BRUK é a inovação do mercado do fitness. Temos como princípio a formação de uma comunidade que além de treinar, está comprometida em evoluir constantemente.</p>
                                <p>Nosso senso de comunidade está presente em todos os setores da BRUK, dos sócios aos alunos.</p>
                                <p>Por isso, queremos você ainda mas próximo, oferecemos a você a possibilidade de ser um parceiro, um sócio BRUK. Queremos possibilitar a oportunidade de ter uma BRUK para chamar de sua. Queremos você comprometido em mudar a realidade do sedentarismo mundial entregando saude e qualidade de vida a milhares de pessoas junto conosco.</p>
                                <p>Se você tem interesse em investir na marca mais forte do mercado e se juntar a este mega projeto, faça agora um contato conosco.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-section section-6" id="franquia">
                    <h2 data-aos="fade-up" data-aos-delay="50">Quer ser um franqueado?</h2>
                    <div className="row pt-4 pb-4">
                        <div className="col-md-6 m-auto" data-aos="fade-up" data-aos-delay="150">
                            <p data-aos="fade-up" data-aos-delay="100">Entre em contato com uma mensagem pelo Whatsapp<br />ou preencha o formulário abaixo, é bem rápido!</p>
                            <div className="row gy-3">
                                <div className="col-xl-10 m-auto">
                                    <label className="form-label">Nome:</label>
                                    <input type="text" className="form-control form-control-light" value={name} onChange={e => setName(e.target.value)} />
                                </div>
                                <div className="col-xl-10 m-auto">
                                    <label className="form-label mt-4">E-mail:</label>
                                    <input type="email" className="form-control form-control-light" value={email} onChange={e => setEmail(e.target.value)} />
                                </div>
                                <div className="col-xl-10 m-auto">
                                    <label className="form-label mt-4">Telefone:</label>
                                    <InputMask type="tel" className="form-control form-control-light" mask="(99) 99999-9999" value={phone} onChange={e => setPhone(e.target.value)} />
                                </div>
                                <div className="col-xl-10 m-auto">
                                    <label className="form-label mt-4">Em qual cidade gostaria de abrir sua BRUK?:</label>
                                    <input type="text" className="form-control form-control-light" value={city} onChange={e => setCity(e.target.value)} />
                                </div>
                                <div className="col-xl-10 m-auto">
                                    <label className="form-label mt-4">Nos conte um pouco sobre você:</label>
                                    <textarea className="form-control form-control-light" rows="3" value={message} onChange={e => setMessage(e.target.value)}></textarea>
                                </div>
                                <div className="col-xl-10 m-auto mt-4">
                                    <div className="text-end">
                                        <button className="btn btn-primary-light btn-wave waves-effect waves-light" onClick={submitContact}>Enviar</button>
                                    </div>
                                </div>
                                {error &&
                                <div className="col-xl-10 m-auto mt-4">
                                    <div className="alert alert-danger">
                                        {error_message}
                                    </div>
                                </div>}
                                {success &&
                                <div className="col-xl-10 m-auto mt-4">
                                    <div className="alert alert-success">
                                        Informações enviadas com sucesso!
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
}
